/**********安卓端的操作**************/

/**
 * 分享
 * @param  {Object}  config
 * @param  {String}  config.title 分享标题
 * @param  {Object}  config.desc 分享描述
 * @param  {Object}  config.url 分享链接
 * @param  {Object}  config.img  分享缩略图
 * @return {promise} 返回一个是否成功分享的promise
 */
function share(config = {}) {
  return new Promise((resolve, reject) => {
    try {
      console.log("android", config);
      window.AndroidWebView.jscallShare(
        config.title,
        config.desc,
        config.url,
        config.img
      );
      resolve();
    } catch (e) {
      // if (e.name == "TypeError") {
      //   alert("点击右上角分享给同学↗↗︎︎");
      // }
      reject(e);
    }
  });
}

// 注册进代理对象
const install = Vue => {
  Vue.prototype.$tools = {
    share
  };
};

export default install;
